module.exports = __webpack_public_path__ + "5b5dc9e1d23258cdffb274765c29b86e.svg";